import { Outlet, NavLink, Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";
import styles from "./Layout.module.css";
import xlicon from "../../assets/xlaxiata-icon.png";
import { loginRequest } from "../login/authConfig";
import { GraphData } from "../../utils/ProfileData";
import { InteractionStatus, InteractionRequiredAuthError, AccountInfo } from "@azure/msal-browser";
import { callMsGraph } from "../../utils/MsGraphApiCall";

const Layout = () => {
    const { instance, inProgress } = useMsal();
    const [graphData, setGraphData] = useState<null | GraphData>(null);
    useEffect(() => {
        if (!graphData && inProgress === InteractionStatus.None) {
            callMsGraph()
                .then(response => setGraphData(response))
                .catch(e => {
                    if (e instanceof InteractionRequiredAuthError) {
                        instance.acquireTokenRedirect({
                            ...loginRequest,
                            account: instance.getActiveAccount() as AccountInfo
                        });
                    }
                });
        }
    }, [inProgress, graphData, instance]);

    function logOut() {
        instance.logoutRedirect(loginRequest);
    }

    function renderLogout() {
        if (!graphData) {
            <NavLink to="/" className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>
                Log In
            </NavLink>
        }

        return (
            <NavLink to="#" onClick={e => logOut()} className={({ isActive }) => (isActive ? styles.headerNavPageLinkActive : styles.headerNavPageLink)}>
                Log Out
            </NavLink>
        );
    }

    return (
        <div className={styles.layout}>
            <header className={styles.header} role={"banner"}>
                <div className='d-flex justify-content-between align-items-center mx-4'>
                    <Link to="/" className="d-flex align-items-end">
                        <img src={xlicon} alt="XL Axiata Logo" height="35px" />
                        <span className="text-white fs-5 fw-bold"><span className='fs-6'>XL AXIATA</span> GPT</span>
                    </Link>
                    <nav>
                        <ul className={styles.headerNavList}>
                            <li className={styles.headerNavLeftMargin}>{renderLogout()}</li>
                        </ul>
                    </nav>
                </div>
            </header>

            <div className={styles.headerBuffer}></div>

            <Outlet />
        </div>
    );
};

export default Layout;
